import { createRoutine } from 'redux-saga-routines';

export const getBrmUnstakeRoutine = createRoutine('brm/UNSTAKE_BRM');


export const getBrmStakeRoutine = createRoutine('brm/STAKE_BRM');


export const getBrmBalanceRoutine = createRoutine('brm/GET_BRM_BALANCE');
